import React from 'react'
import { useMediaQuery, useTheme, Dialog, IconButton } from '@material-ui/core'

import AlertForm from 'shared/components/AlertForm/AlertForm'
import IconFactory from 'icons/IconFactory/IconFactory.jsx'
import { useStyles } from './JobAlertEditModal_style'

const JobAlertEditModal = (props) => {
    const { alert, handleSubmit, isOpen, closeModal } = props
    const classes = useStyles()
    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

    return (
        <Dialog
            open={isOpen}
            fullScreen={fullScreen}
            onClose={closeModal}
            fullWidth
            PaperProps={{ className: classes.dialogContainer }}
        >
            <IconButton aria-label="close" onClick={closeModal} className={classes.closeIconButton} disableRipple>
                <IconFactory icon='close' color={'var(--background-black)'} fontSize='20px' />
            </IconButton>
            <AlertForm
                alert={alert}
                handleSubmit={handleSubmit}
                formType={'edit'}
            />
        </Dialog>
    )
}

export default JobAlertEditModal
